import React from 'react';
import { Select } from 'antd';

import TransactionCreativeTable from './TransactionCreativeTable';
import TransactionCreativeRingChart from './TransactionCreativeRingChart';
import EntityBreakdownCard from '../../../../../../../shared/designSystem/components/EntityBreakdownCard';
import { prepareCTR } from '../../../../../../../../core/utils/campaigns';
import { MenuItemText } from '../../../../../../../shared/globalStyling/styledText';
import { getRingColor } from '../../../../../../../shared/designSystem/components/BreakdownRingChart';

// =============================================================================
// TransactionCreativeDetails (V1) — migrated from the AntD Card / Row / Col
// pattern to the shared `.campaign-overview__creatives` section vocabulary.
// Mirrors the V2 TransactionCreativesDetails shape: eyebrow + Show-By control
// in the head, DataTable + BreakdownRingChart in a 70/30 body split.
//
// Upstream data shape preserved verbatim — the component still accepts
// `transactionsCreatives` with UPPERCASE keys, runs prepareCTR, and assigns
// slice colors from the shared palette. Only the chrome changes.
// =============================================================================

const { Option } = Select;

const SHOW_BY_OPTIONS = [
  { value: 'impressions', text: 'Impressions' },
  { value: 'totalTransactions', text: 'Transactions' },
];

const TransactionCreativeDetails = ({
  transactionsCreatives,
  setCreativeDimension,
  creativeDimension,
}) => {
  if (!transactionsCreatives || transactionsCreatives.length === 0) return null;

  const formatTransactionData = transactionsCreatives.map((val) => ({
    creativeUrl: val.CREATIVEURL,
    impressions: val.impressions,
    totalTransactions: val.totalTransactions,
    targetUrl: val.TARGETURL,
    xAxis: val.CREATIVENAME ? val.CREATIVENAME : val.CREATIVEID,
  }));

  if (!formatTransactionData || formatTransactionData.length === 0) return null;

  const parsedData = prepareCTR(formatTransactionData);
  if (!parsedData || parsedData.length === 0) return null;

  const colorValuePairs = parsedData.map((el, index) => {
    if (el.xAxis) {
      return { ...el, value: el.xAxis, color: getRingColor(index) };
    } else if (el.value) {
      return { ...el, color: getRingColor(index) };
    }
    return { ...el, value: `Creative ${index}`, color: getRingColor(index) };
  });

  if (!colorValuePairs || colorValuePairs.length === 0) return null;

  return (
    <EntityBreakdownCard
      title="Creatives"
      table={<TransactionCreativeTable creativeData={colorValuePairs} />}
      breakdownControl={
        <Select
          defaultValue={SHOW_BY_OPTIONS[0].value}
          onChange={(value) => setCreativeDimension(value)}
          getPopupContainer={(trigger) => trigger.parentNode}
          popupClassName="mjl-ds"
          className="campaign-overview__creatives-showby"
          size="small"
        >
          {SHOW_BY_OPTIONS.map((option) => (
            <Option key={option.value} value={option.value}>
              <MenuItemText text={option.text} />
            </Option>
          ))}
        </Select>
      }
      breakdownChart={
        <TransactionCreativeRingChart
          data={colorValuePairs}
          height={480}
          selectedCreativeDimension={creativeDimension}
        />
      }
    />
  );
};

export default TransactionCreativeDetails;
